import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";
import ViewPostagem from "../views/ViewPostagem";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;
const Postagem: React.FC = () => (
  <ContainerComponente>
    <ViewAppBar />
    <ViewPostagem />
    <ViewFooter />
  </ContainerComponente>
);

export default Postagem;
